import React from "react";
import Spinner from "react-spinkit";

import { LoadingContent } from "./Loading.elements";

function Loading() {
  return (
    <LoadingContent>
      <Spinner name="ball-spin-fade-loader" color="white" fadeIn="none" />
    </LoadingContent>
  );
}

export default Loading;
